import { Grid } from '@mui/material';
import ButtonGeneral from '../../../../components/general/buttons/buttonGeneral';
import Save from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

export const Buttons = ({
    onSave,
    onClose,
}: {
    onSave: () => void;
    onClose: (value: boolean) => void;
}) => {
    return (
        <Grid item xs={12} mt={1} sx={{ textAlign: 'right' }}>
            <ButtonGeneral
                onClick={onSave}
                startIcon={<Save />}
                title="Guardar"
                sx={{ mr: 1 }}
            />
            <ButtonGeneral
                onClick={onClose}
                startIcon={<CancelIcon />}
                title="Cancelar"
            />
        </Grid>
    );
};
